
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useNavigate } from "react-router-dom";

const CallForKnowledgeForm = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white flex flex-col items-center p-4 pb-12">
      {/* Logo */}
      <div className="mt-12 mb-6">
        <img 
          src="/lovable-uploads/bb3f5ac9-6c4b-494d-9a60-86ee7a3feb77.png" 
          alt="iSPAI Logo" 
          className="h-16 cursor-pointer"
          onClick={() => navigate("/engage")}
        />
      </div>

      {/* Title */}
      <h1 className="text-3xl font-bold text-black mb-8 text-center">
        iSPAI Call for Knowledge (CfK)
      </h1>

      <div className="w-full max-w-4xl">
        {/* Purpose Card */}
        <Card className="mb-8 border border-gray-200">
          <CardContent className="pt-6">
            <h2 className="text-xl font-bold text-center mb-4">Purpose</h2>
            <p className="text-gray-700 leading-relaxed">
              This form facilitates the formal process for contributing specialized knowledge to the iSPAI platform. 
              It serves as a mechanism for enriching our collective intelligence through expert insights, 
              research findings, and experiential wisdom. Knowledge contributions may include domain expertise, 
              methodologies, frameworks, best practices, or innovative approaches that advance understanding 
              in specific fields. This process ensures that the iSPAI platform continues to evolve as a 
              comprehensive, authoritative, and valuable resource for its community.
            </p>
          </CardContent>
        </Card>

        {/* Instructions Card */}
        <Card className="mb-8 border border-gray-200">
          <CardContent className="pt-6">
            <h2 className="text-xl font-bold text-center mb-4">Instructions</h2>
            
            <div className="space-y-6">
              <div>
                <h3 className="font-semibold">1. Identify Your Knowledge Domain</h3>
                <p className="text-gray-700 ml-5 mt-1">
                  Specify the field or subject area to which your knowledge contribution pertains, including any 
                  relevant subdisciplines or specialized focus areas.
                </p>
              </div>

              <div>
                <h3 className="font-semibold">2. Define the Knowledge Scope</h3>
                <p className="text-gray-700 ml-5 mt-1">
                  Clearly articulate the boundaries, depth, and breadth of the knowledge you are contributing 
                  (e.g., theoretical framework, practical methodology, case study, empirical findings).
                </p>
              </div>

              <div>
                <h3 className="font-semibold">3. Provide Supporting Evidence</h3>
                <p className="text-gray-700 ml-5 mt-1">
                  Include references, citations, data sources, or experiential validation that substantiates 
                  the accuracy and reliability of your knowledge contribution.
                </p>
              </div>

              <div>
                <h3 className="font-semibold">4. Indicate Applications and Implications</h3>
                <p className="text-gray-700 ml-5 mt-1">
                  Describe how this knowledge can be applied in practical contexts and what implications 
                  it might have for related fields or future developments.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Next Button */}
        <div className="flex justify-center mt-8">
          <Button 
            className="bg-[#14213d] hover:bg-[#0d1829] text-white px-8 py-2 rounded"
            onClick={() => navigate("/call-for-knowledge/functional-area")}
          >
            Next: Select Knowledge Domain
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CallForKnowledgeForm;
